export default __webpack_public_path__ + "static/media/b13a0cc819ec28f041fed646c57e8b73.svg";